module.exports = __webpack_public_path__ + "static/rooms-26b6b7d6cc27933deb050b8e9d3061bb.jpg";